export default function() {
  
  const widgetName = 'swiperWidget';
  const widgetOpts = swiperWidgetOpts;

  const swiperContainers = `
    <div class="swiper-container-images-outer">
      <div class="swiper-container swiper-container-images">
        <div class="swiper-wrapper">
        </div>
        <div class="swiper-button-prev">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M73.22 256l160.1-167.4c9.125-9.594 8.844-24.78-.75-33.94S207.8 45.84 198.7 55.4l-176 184c-8.875 9.313-8.875 23.88 0 33.19l176 184c9.156 9.563 24.34 9.907 33.94 .75C237.5 452.6 240 446.3 240 440c0-5.969-2.219-11.94-6.656-16.59L73.22 256zM425.3 423.4L265.2 256l160.1-167.4c9.125-9.594 8.844-24.78-.75-33.94s-24.78-8.813-33.94 .75l-176 184c-8.875 9.313-8.875 23.88 0 33.19l176 184c9.156 9.563 24.34 9.907 33.94 .75C429.5 452.6 432 446.3 432 440C432 434 429.8 428.1 425.3 423.4z"/></svg>
        </div>
        <div class="swiper-button-next">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M233.3 239.4l-176-184C48.19 45.84 33 45.49 23.41 54.65C18.47 59.37 16 65.68 16 71.99c0 5.969 2.219 11.94 6.656 16.59L182.8 256l-160.1 167.4c-9.125 9.594-8.844 24.78 .75 33.94c9.594 9.156 24.78 8.813 33.94-.75l176-184C242.2 263.3 242.2 248.7 233.3 239.4zM425.3 239.4l-176-184C240.2 45.84 225 45.49 215.4 54.65C210.5 59.37 208 65.68 208 71.99c0 5.969 2.219 11.94 6.656 16.59L374.8 256l-160.1 167.4c-9.125 9.594-8.844 24.78 .75 33.94c9.594 9.156 24.78 8.813 33.94-.75l176-184C434.2 263.3 434.2 248.7 425.3 239.4z"/></svg>
        </div>
      </div>
    </div>

    <div class="swiper-container swiper-container-content">
      <div class="swiper-pagination"></div>
      <div class="swiper-wrapper">
      </div>
    </div>
  `;


  // Slide Template - Images
  function buildSlideTemplateImages(slide) {

    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {

    const title = `<span class="slide-title">${slide.Title}</span>`;

    const buttons = function(btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn2) {
          btnContainer.append(`<a href="${btn2}" class="button">${btn2Text}</a>`);
        }        
        if (btn1) {
          btnContainer.append(`<a href="${btn1}" class="button">${btn1Text}</a>`);
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    }

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          ${title}
          ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
        </div>
      </div>
    `;

    return template;
  }


  // Swiper Initialization
  function initSwiper(widgetData) {
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(`#${widgetName} .swiper-container-content .swiper-wrapper`);

    const onlyOneSlide = () => {
      const moreThanOne = swiperWidgetImagesWrapper.find('.swiper-slide').length > 1 ? true : false;
      if (!moreThanOne) {
        $(`#${widgetName}`).addClass('one-slide');
      }
      return moreThanOne;
    }
    
    widgetData.forEach(function(slide, i) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });


    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: false,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      a11y: true,
      autoHeight: true,     
      allowTouchMove: onlyOneSlide(),
      loop: onlyOneSlide(),
      effect: 'slide',
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    }); 

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      autoplay: false,
      spaceBetween: 0,
      centeredSlides: false,
      a11y: true,
      autoHeight: true,
      allowTouchMove: onlyOneSlide(),
      loop: onlyOneSlide(),
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });  

    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

  }

  
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function(response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(swiperContainers);
      initSwiper(response.Slides);
      // console.log(response.Slides);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });

}
